import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makePresentable } from '@iotv/datamodel-core';
import { Button, Grid, Stack, ToggleButton } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { serviceOfferings } from '../../../../../ArbitrationObjects/serviceOfferings';
import { DialogWrapper } from '../../../../../components/common/DiaglogWrapper';
import { AppMainViewContext } from '../../../../../ContextProviders/AppContextProvider';
import { CustomerDAO } from '../../../../../data/SystemManagementDAO';
import { commonButtonProps } from './Controls/common';
import useDetailCard from './useDetailCard';
import { ComponentMode } from '../../../../../types';
const debug = process.env.REACT_APP_DEBUG && false;
export const CustomerDetailCard = (props) => {
    debug && console.log('CustomerDetailCard', 'allowed actions', props.allowedActions);
    const [{ contextUser, userSelectedGroup }] = useContext(AppMainViewContext);
    const [isAdmin, setIsAdmin] = useState(false);
    useEffect(() => {
        if (!contextUser)
            return;
        CustomerDAO.canAdminCustomer({ contextUser, customer: props.matchedPrimary }).then((admin_res) => {
            setIsAdmin(admin_res.data ?? false);
        });
    }, [contextUser?.sk]);
    const { detailCardComponents, localObject: localCustomer, setLocalObject: setLocalCustomer, editMode } = useDetailCard(props);
    const [serviceOfferingsOpen, setServiceOfferingsOpen] = useState(false);
    const allServiceOfferings = serviceOfferings;
    const updateServiceOfferings = (offering) => {
        if (!localCustomer.serviceOfferings) {
            setLocalCustomer((old) => ({ ...old, serviceOfferings: [offering] }));
            // If we get rid of the last offering, and the matched primary has no service offerings, we need to delete service offerings from the local object to keep synced
        }
        else if (localCustomer.serviceOfferings.includes(offering)) {
            const newOfferings = localCustomer.serviceOfferings.filter((so) => so !== offering);
            if (newOfferings.length === 0 && !props.matchedPrimary.serviceOfferings) {
                setLocalCustomer((old) => {
                    delete old.serviceOfferings;
                    return { ...old };
                });
            }
            else {
                setLocalCustomer((old) => ({ ...old, serviceOfferings: newOfferings }));
            }
        }
        else {
            setLocalCustomer((old) => ({ ...old, serviceOfferings: [...old.serviceOfferings, offering] }));
        }
    };
    return (_jsxs(Stack, { gap: 1, children: [isAdmin && Object.keys(allServiceOfferings).length > 0 ? (_jsxs(Grid, { container: true, spacing: 1, children: [_jsx(Grid, { size: { xs: 12, md: 2 }, order: { xs: 2, sm: 2, md: 1, lg: 1, xl: 1 }, children: _jsx(Stack, { alignItems: 'center', justifyContent: 'center', sx: { height: '100%' }, children: _jsx(Button, { ...commonButtonProps, sx: { ...commonButtonProps.sx, maxWidth: '100%', width: '100%' }, onClick: () => setServiceOfferingsOpen(true), disabled: editMode !== ComponentMode.EDIT, children: "Service Offering" }) }) }), _jsx(Grid, { size: { xs: 12, md: 10 }, order: { xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }, children: detailCardComponents.controls })] })) : (detailCardComponents.controls), detailCardComponents.table, _jsx(DialogWrapper, { slotProps: { paper: { sx: { minHeight: '65dvh', minWidth: '40dvw' } } }, fullWidth: false, open: serviceOfferingsOpen, setClosed: () => {
                    setServiceOfferingsOpen(false);
                }, header: 'Service Offering', children: _jsx(Stack, { gap: 1, children: Object.entries(allServiceOfferings).map(([offering, offeringData]) => {
                        return (_jsx(ToggleButton, { value: offering, selected: localCustomer.serviceOfferings?.includes(offering), onChange: (e) => {
                                updateServiceOfferings(offering);
                            }, color: 'info', sx: { textTransform: 'none' }, disabled: !isAdmin, children: offeringData.label ?? makePresentable(offering) }, offering));
                    }) }) })] }));
};
